import { SqlQueryGuard } from './sql-query.guard';

export const guards: any[] = [SqlQueryGuard];

export * from './sql-query.guard';
